export default {
    title: 'Maßnahme',

    organisation_id: 'Organisations-ID',
    creator_user_id: 'Ersteller*in-ID',
    year_id: 'Jahres-ID',

    name: 'Titel',
    location: 'Ort',
    date: 'Datum',
    startDate: 'Startdatum',
    start_date: 'Startdatum',
    endDate: 'Enddatum',
    end_date: 'Enddatum',
    duration: 'Dauer',
    durationDays: '{count} Tage|{count} Tag|{count} Tage',
    address: 'Adresse',
    street: 'Straße',
    house_number: 'Hausnummer',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    locationIndependent: 'Ortsungebundene Maßnahme',

    editEvent: 'Maßnahme bearbeiten',
    saveEvent: 'Maßnahme speichern',
    successfullySaved: 'Maßnahme wurde erfolgreich gespeichert.',
    couldNotBeSaved: 'Die Maßnahme konnte nicht gespeichert werden.'
}